import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { Collapse, message as AlertAnt } from 'antd';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import ListUsersWithSelect from '../../components/ListUsersWithSelect';
import { instanceAxios } from '../../InstanceAxios';

function EnviarEmail() {
  const { Panel } = Collapse;
  const [content, setContent] = useState('');
  const [assunto, setAssunto] = useState('');
  const [assuntoError, setAssuntoError] = useState(false);
  const [abrirAlert, setAlert] = useState(false);
  const [mensagemAlert, setMensagemAlerta] = useState('');
  const [tipoAlerta, setTipoAlerta] = useState('success');
  const [arrayUserIds, setArrayUserIds] = useState([]);

  const sendEmail = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post('/enviarEmail', {
        arrayIds: arrayUserIds,
        subject: assunto,
        body: content,
      })
      .then(async (result) => {
        console.log(result.data.message);
        setAlert(true);
        setMensagemAlerta(result.data.message);
        setArrayUserIds([]);
        setTipoAlerta('success');
        setAssunto('');
        setContent('');
      })
      .catch((err) => {
        console.log(err.response.data.message);
        setAlert(true);
        setTipoAlerta('error');
        setMensagemAlerta('Sem conexão!');
      });
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlert(false);
  };

  const handleChange = (cont) => setContent(cont);

  const renderEmailContent = (onClickSendMail) => {
    return (
      <>
        <TextField
          id="standard-full-width"
          label="Assunto *"
          style={{ width: '100%' }}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(event) => {
            setAssunto(event.target.value);
          }}
          error={assuntoError}
          value={assunto}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <SunEditor
            lang="pt_br"
            setOptions={{
              height: 200,
              buttonList: [
                [
                  'undo',
                  'redo',
                  'font',
                  'fontSize',
                  'formatBlock',
                  'paragraphStyle',
                  'blockquote',
                  'bold',
                  'underline',
                  'italic',
                  'strike',
                  'subscript',
                  'superscript',
                  'fontColor',
                  'hiliteColor',
                  'textStyle',
                  'removeFormat',
                  'outdent',
                  'indent',
                  'align',
                  'horizontalRule',
                  'list',
                  'lineHeight',
                  'table',
                  'link',
                  'image',
                  'video',
                  'audio',
                  'codeView',
                ],
              ],
            }}
            onChange={handleChange}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10,
          }}
        >
          <Button
            variant="contained"
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
            onClick={onClickSendMail}
          >
            ENVIAR EMAIL
          </Button>
        </div>
      </>
    );
  };

  return (
    <div style={{ margin: 25 }}>
      <div style={{ marginLeft: -6, paddingRight: 9 }}>
        <Paper
          elevation={3}
          style={{
            marginBottom: 10,
            paddingTop: 20,
            paddingBottom: 20,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h1
            style={{
              fontSize: 25,
              h1Align: 'center',
              fontWeight: 'bold',
              color: '#030d4f',
            }}
          >
            Enviar E-Mail
          </h1>
        </Paper>
        <Collapse accordion>
          <Panel header="Enviar e-mail para uma lista de usuários" key="1">
            <ListUsersWithSelect
              setArrayUserIds={(array) => {
                setArrayUserIds(array);
              }}
              arrayUserIds={arrayUserIds}
            />
            {renderEmailContent(() => {
              setArrayUserIds([]);
              sendEmail();
            })}
          </Panel>
          <Panel header="Enviar e-mail para todos os usuários" key="2">
            {renderEmailContent(() => {
              setArrayUserIds([]);
              sendEmail();
            })}
          </Panel>
        </Collapse>
      </div>
      <Snackbar open={abrirAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity={tipoAlerta} onClose={handleClose}>
          {mensagemAlert}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default EnviarEmail;
